<template lang="pug">
  div.validation-message(
      v-if="message && message.length > 0"
      :class="'message-type-' + type"
    )
    div.svg-icon(v-if="type === 'error'")
      svg(viewBox="0 0 32 32" class="svgicon" aria-hidden="true" focusable="false")
        path(d="M9.79 1.27a15.87 15.87 0 0 1 12.42 0 15.75 15.75 0 0 1 8.52 8.52 15.87 15.87 0 0 1 0 12.42 15.75 15.75 0 0 1-8.52 8.52 15.87 15.87 0 0 1-12.42 0 15.75 15.75 0 0 1-8.52-8.52 15.87 15.87 0 0 1 0-12.42 15.75 15.75 0 0 1 8.52-8.52zM16 30a13.69 13.69 0 0 0 5.44-1.11 14.13 14.13 0 0 0 4.47-3 14 14 0 0 0 3-4.46 13.92 13.92 0 0 0 0-10.89 13.76 13.76 0 0 0-7.45-7.45 13.92 13.92 0 0 0-10.89 0 14 14 0 0 0-4.46 3 14.13 14.13 0 0 0-3 4.47 13.92 13.92 0 0 0 0 10.89 13.7 13.7 0 0 0 7.44 7.44A13.72 13.72 0 0 0 16 30zm6.22-17.5l-3.5 3.5 3.5 3.5-2.72 2.72-3.5-3.5-3.53 3.5-2.69-2.72 3.5-3.5-3.5-3.5 2.69-2.72 3.53 3.5 3.5-3.5z")
    span.validation-text {{ message }}
</template>
<script>
export default {
  name: 'ValidationMessage',
  props: ['message', 'source-type'],
  data() {
    return {
      type: 'error'
    };
  },
  mounted() {
    if (this.sourceType && this.sourceType.length > 0) {
      this.type = this.sourceType;
    }
  }
};
</script>
<style lang="scss" scoped>
.validation-message {
  margin-top: 6px;
  margin-bottom: 16px;
  font-size: 11px;
  font-weight: 600;
  color: $md-red-700;

  @include media-query-bp($bp5) {
    font-size: 14px;
  }

  &.message-type-error {
    color: $md-red-700;
  }
  &.message-type-success {
    color: $success-color;
    font-size: 1.25em;
  }

  div.svg-icon {
    display: inline;
    position: relative;
    top: 1px;

    svg {
      height: 17px;
      width: 17px;
    }
  }
  .validation-text {
    line-height: 1.33;
    margin-left: 4px;
  }
}
</style>
